<div class="w-full min-h-screen bg-pattern grid place-items-center">
  <div class="w-full max-h-screen overflow-y-auto px-4">
    <div class="w-full max-w-3xl mx-auto my-20 bg-white/70 backdrop-blur-xl shadow-2xl rounded-2xl overflow-hidden">
      <div class="p-6 pb-0 flex flex-col items-center justify-center">
        <div class="fill-current text-center">
          <img class="w-64" src="assets/images/login-register/logo_clarity_color2.svg" alt="Logo Clarity" />
        </div>
      </div>

      <div class="text-center mt-4">
        <h2 class="title m-0">Regístrate para obtener una cuenta</h2>
        <h4 class="body-2 text-secondary m-0">Ingresa tus datos en el siguiente formulario</h4>
      </div>

      <mat-horizontal-stepper #stepper="matHorizontalStepper" [linear]="true">

        <ng-template matStepperIcon="edit">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
            <path fill="white"
              d="M16.62 6.21a1 1 0 0 0-1.41.17l-7 9l-3.43-4.18a1 1 0 1 0-1.56 1.25l4.17 5.18a1 1 0 0 0 .78.37a1 1 0 0 0 .83-.38l7.83-10a1 1 0 0 0-.21-1.41m5 0a1 1 0 0 0-1.41.17l-7 9l-.61-.75l-1.26 1.62l1.1 1.37a1 1 0 0 0 .78.37a1 1 0 0 0 .78-.38l7.83-10a1 1 0 0 0-.21-1.4" />
            <path fill="white" d="M8.71 13.06L10 11.44l-.2-.24a1 1 0 0 0-1.43-.2a1 1 0 0 0-.15 1.41Z" />
          </svg>
        </ng-template>

        <ng-template matStepperIcon="done">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
            <path fill="white"
              d="M16.62 6.21a1 1 0 0 0-1.41.17l-7 9l-3.43-4.18a1 1 0 1 0-1.56 1.25l4.17 5.18a1 1 0 0 0 .78.37a1 1 0 0 0 .83-.38l7.83-10a1 1 0 0 0-.21-1.41m5 0a1 1 0 0 0-1.41.17l-7 9l-.61-.75l-1.26 1.62l1.1 1.37a1 1 0 0 0 .78.37a1 1 0 0 0 .78-.38l7.83-10a1 1 0 0 0-.21-1.4" />
            <path fill="white" d="M8.71 13.06L10 11.44l-.2-.24a1 1 0 0 0-1.43-.2a1 1 0 0 0-.15 1.41Z" />
          </svg>
        </ng-template>

        <!-- PASO 1: Información Personal -->
        <mat-step [stepControl]="personalInfoFormGroup">
          <form [formGroup]="personalInfoFormGroup">
            <ng-template matStepLabel>Información Personal</ng-template>

            <h2 class="title m-0">Información Personal</h2>
            <div class="subheading-1">
              Introduce tus datos personales.
            </div>

            <div class="mt-4 flex flex-col gap-2">

              <div class="flex flex-col sm:flex-row gap-2 sm:gap-6">
                <mat-form-field appearance="outline" class="flex-auto">
                  <mat-label>Nombres</mat-label>
                  <input formControlName="nombre" matInput required />
                  <mat-error *ngIf="personalInfoFormGroup.controls['nombre'].errors?.['required'] && personalInfoFormGroup.controls['nombre'].touched">
                    El nombre es requerido.
                  </mat-error>
                  <mat-error *ngIf="personalInfoFormGroup.controls['nombre'].errors?.['minlength']">
                    Tener al menos 3 caracteres.
                  </mat-error>
                  <mat-error *ngIf="personalInfoFormGroup.controls['nombre'].errors?.['maxlength']">
                    El nombre no debe exceder los 30 caracteres.
                  </mat-error>
                  <mat-error *ngIf="personalInfoFormGroup.controls['nombre'].errors?.['pattern']">
                    Solo se permiten letras en el Nombre.
                  </mat-error>
                  <mat-error *ngIf="personalInfoFormGroup.controls['nombre'].errors?.['sanitize']?.hasHTMLTags">
                    No debe contener etiquetas HTML.
                  </mat-error>
                  <mat-error *ngIf="personalInfoFormGroup.controls['nombre'].errors?.['sanitize']?.hasMaliciousChars">
                    Contiene caracteres no permitidos.
                  </mat-error>
                  <mat-error *ngIf="personalInfoFormGroup.controls['nombre'].errors?.['sanitize']?.hasSQLInjection">
                    Posible patrón malicioso.
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="flex-auto">
                  <mat-label>Apellidos</mat-label>
                  <input formControlName="apellido" matInput required />
                  <mat-error *ngIf="personalInfoFormGroup.controls['apellido'].errors?.['required'] && personalInfoFormGroup.controls['apellido'].touched">
                    El apellido es requerido.
                  </mat-error>
                  <mat-error *ngIf="personalInfoFormGroup.controls['apellido'].errors?.['minlength']">
                    Tener al menos 3 caracteres.
                  </mat-error>
                  <mat-error *ngIf="personalInfoFormGroup.controls['apellido'].errors?.['maxlength']">
                    El apellido no debe exceder los 40 caracteres.
                  </mat-error>
                  <mat-error *ngIf="personalInfoFormGroup.controls['apellido'].errors?.['sanitize']?.hasHTMLTags">
                    No debe contener etiquetas HTML.
                  </mat-error>
                  <mat-error *ngIf="personalInfoFormGroup.controls['apellido'].errors?.['sanitize']?.hasMaliciousChars">
                    Contiene caracteres no permitidos.
                  </mat-error>
                  <mat-error *ngIf="personalInfoFormGroup.controls['apellido'].errors?.['sanitize']?.hasSQLInjection">
                    Posible patrón malicioso.
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="flex flex-col sm:flex-row gap-2 sm:gap-6">
                <mat-form-field appearance="outline" class="flex-auto">
                  <mat-label>Tipo de Documento</mat-label>
                  <mat-select formControlName="tipoDocIdent" required>
                    <mat-option *ngFor="let type of tiposDocumentos" [value]="type">
                      {{ type }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="personalInfoFormGroup.controls['tipoDocIdent'].invalid && personalInfoFormGroup.controls['tipoDocIdent'].touched">
                    El tipo de documento es requerido
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="flex-auto">
                  <mat-label>Número de Documento</mat-label>
                  <input formControlName="numDocIdent" matInput required
                    [tipoDocIdent]="personalInfoFormGroup.get('tipoDocIdent')?.value" appDocumentNumber />
                  <mat-error *ngIf="personalInfoFormGroup.controls['tipoDocIdent']?.value === '' && personalInfoFormGroup.controls['numDocIdent'].touched">
                    Campo obligatorio.
                  </mat-error>
                  <mat-error *ngIf="personalInfoFormGroup.controls['tipoDocIdent']?.value === 'Cédula de Ciudadanía'">
                    CC debe tener entre 7 y 10 dígitos.
                  </mat-error>
                  <mat-error *ngIf="personalInfoFormGroup.controls['tipoDocIdent']?.value === 'Pasaporte'">
                    PA entre 5 y 20 caracteres.
                  </mat-error>
                  <mat-error *ngIf="personalInfoFormGroup.controls['tipoDocIdent']?.value === 'Tarjeta de Identidad'">
                    TI debe tener entre 7 y 12 dígitos.
                  </mat-error>
                  <mat-error *ngIf="personalInfoFormGroup.controls['tipoDocIdent']?.value === 'Cédula de Extranjería'">
                    CE debe tener entre 7 y 15 caracteres.
                  </mat-error>
                  <mat-error *ngIf="personalInfoFormGroup.controls['tipoDocIdent']?.value === 'Permiso por Protección Temporal'">
                    PPT debe tener entre 6 y 15 dígitos.
                  </mat-error>
                </mat-form-field>

                <div class="md:col-span-1 lg:col-span-2">
                  <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Número de Celular</mat-label>
                    <span matPrefix class="text-gray-500 mr-2">+57</span>
                    <input formControlName="numTelefono" matInput required minlength="10" maxlength="10" pattern="^[3][0-9]{9}$" />
                    <mat-error *ngIf="personalInfoFormGroup.controls['numTelefono'].errors?.['required'] && personalInfoFormGroup.controls['numTelefono'].touched">
                      Número de celular requerido.
                    </mat-error>
                    <mat-error *ngIf="personalInfoFormGroup.controls['numTelefono'].errors?.['pattern']">
                      El número debe tener solo 10 dígitos y comenzar con 3.
                    </mat-error>
                    <mat-error *ngIf="personalInfoFormGroup.controls['numTelefono'].errors?.['sanitize']?.hasHTMLTags">
                      No debe contener etiquetas HTML.
                    </mat-error>
                    <mat-error *ngIf="personalInfoFormGroup.controls['numTelefono'].errors?.['sanitize']?.hasMaliciousChars">
                      Contiene caracteres no permitidos.
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

            </div>

            <div class="actions flex items-center justify-end gap-2 mt-7">
              <button [disabled]="personalInfoFormGroup.invalid" mat-raised-button matStepperNext
                class="auth-btn-primary">
                Siguiente
              </button>
            </div>
            <p class="text-secondary text-center mt-4">
              ¿Ya tienes una cuenta?<br />
              <a [routerLink]="['/iniciar-sesion']" class="text-Teal hover:underline transition-colors duration-200">Ingresa aquí</a>
            </p>
          </form>
        </mat-step>

        <!-- PASO 2: Dirección -->
        <mat-step [stepControl]="currentActiveForm">
          <form *ngIf="currentActiveForm" [formGroup]="currentActiveForm">
            <ng-template matStepLabel>Dirección</ng-template>

            <h2 class="title m-0">Dirección</h2>
            <div class="subheading-1">Introduce tu dirección de residencia.</div>

            <div class="button-group mt-2 flex justify-center gap-2">
              <button mat-raised-button [disabled]="isRural === false"
                [ngClass]="{'active-btn': isRural === false}"
                class="!bg-gray-200 !text-gray-600 hover:!bg-gray-300 !shadow-none"
                (click)="selectZone('urban')">
                Zona Urbana
              </button>
              <button mat-raised-button [disabled]="isRural === true"
                [ngClass]="{'active-btn': isRural === true}"
                class="!bg-gray-200 !text-gray-600 hover:!bg-gray-300 !shadow-none"
                (click)="selectZone('rural')">
                Zona Rural
              </button>
            </div>

            <div *ngIf="isRural === null" class="text-center mt-2">
              <p>Por favor, selecciona una zona para comenzar.</p>
            </div>
            <div *ngIf="isRural === true" class="text-center mt-2 mb-2">
              <p>Ahora, estás en el formulario para zona rural.</p>
            </div>
            <div *ngIf="isRural === false" class="text-center mt-2 mb-2">
              <p>Estás en el formulario para zona urbana.</p>
            </div>

            <div class="scrollable-section">
              <br>
              <!-- Formulario Urbano -->
              <div *ngIf="isRural === false">
                <div class="mt-4 flex flex-col gap-2">

                  <mat-form-field appearance="outline" class="flex-auto">
                    <mat-label>Dirección completa</mat-label>
                    <input matInput formControlName="direccionCompleta" readonly>
                  </mat-form-field>

                  <div class="flex flex-col sm:flex-row gap-2 sm:gap-6">
                    <mat-form-field class="flex-auto" *ngIf="states.length > 0">
                      <mat-label>Departamento</mat-label>
                      <mat-select formControlName="departamento" (selectionChange)="onStateChange()" required>
                        <mat-option *ngFor="let state of states" [value]="state.id">
                          {{ state.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="addressFormGroup.controls['departamento'].invalid && addressFormGroup.controls['departamento'].touched">
                        El departamento es requerido
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="flex-auto">
                      <mat-label>Municipio</mat-label>
                      <mat-select formControlName="municipio" required>
                        <mat-option *ngFor="let city of cities" [value]="city.id">
                          {{ city.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="addressFormGroup.controls['municipio'].invalid && addressFormGroup.controls['municipio'].touched">
                        El municipio es requerido
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col sm:flex-row gap-2 sm:gap-6 mb-4">
                    <mat-form-field appearance="outline" class="flex-auto">
                      <mat-label>Vía Principal</mat-label>
                      <input matInput formControlName="viaPrincipal" minlength="3" maxlength="30" required />
                      <mat-error *ngIf="addressFormGroup.controls['viaPrincipal'].errors?.['required'] && addressFormGroup.controls['viaPrincipal'].touched">
                        Vía principal requerida.
                      </mat-error>
                      <mat-error *ngIf="addressFormGroup.controls['viaPrincipal'].errors?.['pattern']">
                        Solo letras y espacios.
                      </mat-error>
                      <mat-error *ngIf="addressFormGroup.controls['viaPrincipal'].errors?.['minlength']">
                        Mínimo 3 caracteres.
                      </mat-error>
                      <mat-error *ngIf="addressFormGroup.controls['viaPrincipal'].errors?.['maxlength']">
                        Máximo 30 caracteres.
                      </mat-error>
                      <mat-error *ngIf="addressFormGroup.controls['viaPrincipal'].errors?.['sanitize']?.hasHTMLTags">
                        No debe contener etiquetas HTML.
                      </mat-error>
                      <mat-error *ngIf="addressFormGroup.controls['viaPrincipal'].errors?.['sanitize']?.hasMaliciousChars">
                        Contiene caracteres no permitidos.
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="flex-auto">
                      <mat-label>Número de Vía Principal</mat-label>
                      <input matInput formControlName="numViaPrincipal" minlength="1" maxlength="15" required />
                      <mat-error *ngIf="addressFormGroup.controls['numViaPrincipal'].errors?.['required'] && addressFormGroup.controls['numViaPrincipal'].touched">
                        Número de vía principal requerido.
                      </mat-error>
                      <mat-error *ngIf="addressFormGroup.controls['numViaPrincipal'].errors?.['minlength']">
                        Mínimo 1 carácter.
                      </mat-error>
                      <mat-error *ngIf="addressFormGroup.controls['numViaPrincipal'].errors?.['maxlength']">
                        Máximo 7 caracteres.
                      </mat-error>
                      <mat-error *ngIf="addressFormGroup.controls['numViaPrincipal'].errors?.['pattern']">
                        Formato inválido (ej: 18G).
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="flex-auto">
                      <mat-label>#</mat-label>
                      <input matInput formControlName="numViaSecundaria" minlength="1" maxlength="7" required />
                      <mat-error *ngIf="addressFormGroup.controls['numViaSecundaria'].errors?.['required'] && addressFormGroup.controls['numViaSecundaria'].touched">
                        Campo obligatorio.
                      </mat-error>
                      <mat-error *ngIf="addressFormGroup.controls['numViaSecundaria'].errors?.['minlength']">
                        Mínimo 1 carácter.
                      </mat-error>
                      <mat-error *ngIf="addressFormGroup.controls['numViaSecundaria'].errors?.['maxlength']">
                        Máximo 7 caracteres.
                      </mat-error>
                      <mat-error *ngIf="addressFormGroup.controls['numViaSecundaria'].errors?.['pattern']">
                        Formato inválido (ej: 141A).
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="flex-auto">
                      <mat-label>-</mat-label>
                      <input matInput formControlName="numPropiedad" minlength="1" maxlength="7" required />
                      <mat-error *ngIf="addressFormGroup.controls['numPropiedad'].errors?.['required'] && addressFormGroup.controls['numPropiedad'].touched">
                        Campo obligatorio.
                      </mat-error>
                      <mat-error *ngIf="addressFormGroup.controls['numPropiedad'].errors?.['pattern']">
                        Solo números permitidos.
                      </mat-error>
                      <mat-error *ngIf="addressFormGroup.controls['numPropiedad'].errors?.['minlength']">
                        Mínimo 1 carácter.
                      </mat-error>
                      <mat-error *ngIf="addressFormGroup.controls['numPropiedad'].errors?.['maxlength']">
                        Máximo 7 caracteres.
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col sm:flex-row gap-2 sm:gap-6">
                    <div class="flex-auto">
                      <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Barrio</mat-label>
                        <input matInput formControlName="barrio" minlength="3" maxlength="30" required />
                        <mat-error *ngIf="addressFormGroup.controls['barrio'].errors?.['required'] && addressFormGroup.controls['barrio'].touched">
                          El barrio es requerido
                        </mat-error>
                        <mat-error *ngIf="addressFormGroup.controls['barrio'].errors?.['minlength']">
                          El nombre del barrio debe tener al menos 3 caracteres.
                        </mat-error>
                        <mat-error *ngIf="addressFormGroup.controls['barrio'].errors?.['maxlength']">
                          El nombre del barrio no debe exceder los 30 caracteres.
                        </mat-error>
                        <mat-error *ngIf="addressFormGroup.controls['barrio'].errors?.['pattern']">
                          Solo puede contener letras y espacios.
                        </mat-error>
                        <mat-error *ngIf="addressFormGroup.controls['barrio'].errors?.['sanitize']?.hasHTMLTags">
                          No debe contener etiquetas HTML.
                        </mat-error>
                        <mat-error *ngIf="addressFormGroup.controls['barrio'].errors?.['sanitize']?.hasMaliciousChars">
                          Contiene caracteres no permitidos.
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex-auto">
                      <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Complemento</mat-label>
                        <input matInput formControlName="complemento" maxlength="50" />
                        <mat-error *ngIf="addressFormGroup.controls['complemento'].errors?.['maxlength']">
                          El complemento no puede exceder los 50 caracteres.
                        </mat-error>
                        <mat-error *ngIf="addressFormGroup.controls['complemento'].errors?.['sanitize']?.hasHTMLTags">
                          No debe contener etiquetas HTML.
                        </mat-error>
                        <mat-error *ngIf="addressFormGroup.controls['complemento'].errors?.['sanitize']?.hasMaliciousChars">
                          Contiene caracteres no permitidos.
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Formulario Rural -->
              <div *ngIf="isRural === true">
                <div class="mt-4 flex flex-col gap-2">

                  <mat-form-field appearance="outline" class="flex-auto">
                    <mat-label>Dirección completa</mat-label>
                    <input matInput formControlName="direccionCompleta" readonly>
                  </mat-form-field>

                  <div class="flex flex-col sm:flex-row gap-2 sm:gap-6">
                    <mat-form-field class="flex-auto" *ngIf="states.length > 0">
                      <mat-label>Departamento</mat-label>
                      <mat-select formControlName="departamento" (selectionChange)="onStateRuralChange()" required>
                        <mat-option *ngFor="let state of states" [value]="state.id">
                          {{ state.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="ruralAddressFormGroup.controls['departamento'].invalid && ruralAddressFormGroup.controls['departamento'].touched">
                        El departamento es requerido
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="flex-auto">
                      <mat-label>Municipio</mat-label>
                      <mat-select formControlName="municipio" required>
                        <mat-option *ngFor="let city of cities" [value]="city.id">
                          {{ city.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="ruralAddressFormGroup.controls['municipio'].invalid && ruralAddressFormGroup.controls['municipio'].touched">
                        El municipio es requerido
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col sm:flex-row gap-2 sm:gap-6">
                    <div class="flex-auto">
                      <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Tipo de Vía</mat-label>
                        <input matInput formControlName="viaTipo" minlength="3" maxlength="30" required />
                        <mat-error *ngIf="ruralAddressFormGroup.controls['viaTipo'].errors?.['required'] && ruralAddressFormGroup.controls['viaTipo'].touched">
                          Campo requerido.
                        </mat-error>
                        <mat-error *ngIf="ruralAddressFormGroup.controls['viaTipo'].errors?.['minlength']">
                          Mínimo 3 caracteres.
                        </mat-error>
                        <mat-error *ngIf="ruralAddressFormGroup.controls['viaTipo'].errors?.['maxlength']">
                          Máximo 30 caracteres.
                        </mat-error>
                        <mat-error *ngIf="ruralAddressFormGroup.controls['viaTipo'].errors?.['pattern']">
                          Solo letras, números y espacios.
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex-auto">
                      <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Vereda</mat-label>
                        <input matInput formControlName="vereda" minlength="3" maxlength="30" required />
                        <mat-error *ngIf="ruralAddressFormGroup.controls['vereda'].errors?.['required'] && ruralAddressFormGroup.controls['vereda'].touched">
                          Campo requerido.
                        </mat-error>
                        <mat-error *ngIf="ruralAddressFormGroup.controls['vereda'].errors?.['minlength']">
                          Mínimo 3 caracteres.
                        </mat-error>
                        <mat-error *ngIf="ruralAddressFormGroup.controls['vereda'].errors?.['maxlength']">
                          Máximo 30 caracteres.
                        </mat-error>
                        <mat-error *ngIf="ruralAddressFormGroup.controls['vereda'].errors?.['pattern']">
                          Solo letras, números y espacios.
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex-auto">
                      <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Complemento</mat-label>
                        <input matInput formControlName="complemento" maxlength="50" />
                        <mat-error *ngIf="ruralAddressFormGroup.controls['complemento'].errors?.['maxlength']">
                          No puede exceder los 50 caracteres.
                        </mat-error>
                        <mat-error *ngIf="ruralAddressFormGroup.controls['complemento'].errors?.['sanitize']?.hasHTMLTags">
                          No debe contener etiquetas HTML.
                        </mat-error>
                        <mat-error *ngIf="ruralAddressFormGroup.controls['complemento'].errors?.['sanitize']?.hasMaliciousChars">
                          Contiene caracteres no permitidos.
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="actions flex items-center justify-end gap-2 mt-4">
              <button mat-button matStepperPrevious type="button" class="!text-gray-500 hover:!text-gray-700">
                Regresar
              </button>
              <button [disabled]="currentActiveForm!.invalid" mat-raised-button matStepperNext
                class="auth-btn-primary">
                Siguiente
              </button>
            </div>
          </form>
        </mat-step>

        <!-- PASO 3: Credenciales -->
        <mat-step [stepControl]="credentialsFormGroup">
          <form [formGroup]="credentialsFormGroup">
            <ng-template matStepLabel>Credenciales</ng-template>

            <h2 class="title m-0">Credenciales</h2>
            <div class="subheading-1">
              Define el correo electrónico para iniciar sesión.
            </div>

            <div class="mt-4 flex flex-col gap-2">
              <mat-form-field appearance="outline" class="flex-auto">
                <mat-label>Correo</mat-label>
                <input type="email" formControlName="correo" minlength="6" maxlength="245" matInput required />
                <mat-error *ngIf="credentialsFormGroup.controls['correo'].errors?.['required'] && credentialsFormGroup.controls['correo'].touched">
                  El correo electrónico es requerido.
                </mat-error>
                <mat-error *ngIf="credentialsFormGroup.controls['correo'].errors?.['invalidEmail'] || credentialsFormGroup.controls['correo'].errors?.['pattern']">
                  El formato del correo electrónico no es válido.
                </mat-error>
                <mat-error *ngIf="credentialsFormGroup.controls['correo'].errors?.['sanitize']?.hasHTMLTags">
                  El correo no debe contener etiquetas HTML.
                </mat-error>
                <mat-error *ngIf="credentialsFormGroup.controls['correo'].errors?.['sanitize']?.hasMaliciousChars">
                  El correo contiene caracteres no permitidos.
                </mat-error>
                <mat-error *ngIf="credentialsFormGroup.controls['correo'].errors?.['sanitize']?.hasSQLInjection">
                  El campo contiene palabras o patrones potencialmente maliciosos.
                </mat-error>
              </mat-form-field>

              <div class="actions flex items-center justify-end gap-2">
                <button mat-button matStepperPrevious type="button" class="!text-gray-500 hover:!text-gray-700">
                  Regresar
                </button>
                <button [disabled]="credentialsFormGroup.invalid" mat-raised-button matStepperNext
                  class="auth-btn-primary">
                  Siguiente
                </button>
              </div>
            </div>
          </form>
        </mat-step>

        <!-- PASO 4: Confirmar Creación -->
        <mat-step [stepControl]="termsFormGroup">
          <form [formGroup]="termsFormGroup">
            <ng-template matStepLabel>Confirmar Creación</ng-template>

            <div class="title m-0">¡Ya casi terminas!</div>
            <div class="subheading-1">
              Para finalizar el registro, acepta los términos y condiciones del servicio y haz clic en "Crear cuenta".
            </div>
            <div class="subheading-1 text-sm font-light mt-[1rem]">
              <span class="text-sec_rojo font-semibold">Información importante:</span>
              <br>
              <p>Al crear tu cuenta, recibirás un correo de confirmación con una contraseña temporal de 6 dígitos.</p>
              <p>Este paso es fundamental para proteger tu privacidad y garantizar la validez de tu dirección de correo electrónico.</p>
              <p>Una vez inicies sesión por primera vez con esta contraseña, podrás usar en adelante tu clave registrada.</p>
            </div>

            <div class="mt-4 flex flex-col gap-2">
              <mat-checkbox class="checkbox" formControlName="terminos">
                Acepto los <a class="text-Teal hover:underline transition-colors duration-200 cursor-pointer">términos y condiciones</a>.
              </mat-checkbox>
            </div>

            <div class="actions flex items-center justify-end gap-2 mt-4">
              <button mat-button matStepperPrevious type="button" class="!text-gray-500 hover:!text-gray-700">
                Regresar
              </button>
              <button (click)="submit()" [disabled]="termsFormGroup.invalid || isButtonDisabled" mat-raised-button matStepperNext
                class="auth-btn-primary">
                Crear Cuenta
              </button>
            </div>

            <div *ngIf="isButtonDisabled" class="flex items-center justify-center my-4">
              <svg aria-hidden="true" class="inline w-8 h-8 text-slate-400 animate-spin fill-Navy"
                viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor" />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill" />
              </svg>
            </div>
          </form>
        </mat-step>

      </mat-horizontal-stepper>

    </div>
  </div>
</div>
